<template>
  <li :class="customClass || ''">
    <p class="fl-left" :class="color" style="display: contents;">{{ name }}</p>
    <p class="fl-right">
      <b :class="color">{{ amount.toLocaleString() }}</b>
      {{ unit || '건' }}
    </p>
  </li>
</template>
<script>
export default {
  name: 'DashboardCard',
  props: ['unit', 'name', 'amount', 'color', 'customClass']
};
</script>
